import { ArrowBackIcon, ArrowForwardIcon } from '@chakra-ui/icons';
import { Box, Flex, IconButton, Text } from '@chakra-ui/react';

const Pagination = ({ currentPage, totalPages, onPreviousPage, onNextPage, isNextDisabled }) => {
  return (
    <Flex justify='space-between' align='center' mt={4}>
      <Text>
        Page {currentPage} of {totalPages}
      </Text>
      <Box>
        <IconButton icon={<ArrowBackIcon />} onClick={onPreviousPage} disabled={currentPage === 1} />
        <IconButton ml={4} icon={<ArrowForwardIcon />} onClick={onNextPage} disabled={isNextDisabled} />
      </Box>
    </Flex>
  );
};

export default Pagination;
